import {
    Component,
    OnInit,
    ViewChild,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/dialog.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { RegistruService } from './registru.service';
import { Observable, finalize, map, tap } from 'rxjs';
import { GenericRegistru } from 'src/app/interfaces/generic.interface';
import { AddRegistruComponent } from './add-registru/add-registru.component';
import Swal from 'sweetalert2';
import { PermissionsService } from '../../services/permissions.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';
import { NotificationService } from 'src/app/services/notification.service';
import { CertificatUrbanismComponent } from './tabele-registru/certificat-urbanism/certificat-urbanism.component';
import { AcordAdminDrumComponent } from './tabele-registru/acord-admin-drum/acord-admin-drum.component';
import { AutorizatiiConstruireComponent } from './tabele-registru/autorizatii-construire/autorizatii-construire.component';
import { AvizPrincipiuStudiuPubComponent } from './tabele-registru/aviz-principiu-studiu-pub/aviz-principiu-studiu-pub.component';
import { AvizPudComponent } from './tabele-registru/aviz-pud/aviz-pud.component';
import { AvizSupraetajareComponent } from './tabele-registru/aviz-supraetajare/aviz-supraetajare.component';
import { AvizeComponent } from './tabele-registru/avize/avize.component';
import { ToateTabelRegistruComponent } from './tabele-registru/toate-tabel-registru/toate-tabel-registru.component';
import { ConstruireDesfiintareComponent } from './tabele-registru/construire-desfiintare/construire-desfiintare.component';
import { ConstruireDesfiintareIngineriestiComponent } from './tabele-registru/construire-desfiintare-ingineresti/construire-desfiintare-ingineresti.component';
import { OperatiuniNotarialeComponent } from './tabele-registru/operatiuni-notariale/operatiuni-notariale.component';
import { CertificateUrbanismInformareComponent } from './tabele-registru/certificate-urbanism-informare/certificate-urbanism-informare.component';
import { AutorizatieConstruireDesfiintareComponent } from './tabele-registru/autorizatie-construire-desfiintare/autorizatie-construire-desfiintare.component';
import { AvizePrimarComponent } from './tabele-registru/avize-primar/avize-primar.component';
import { NotificariComponent } from './tabele-registru/notificari/notificari.component';
import { MatCalendar } from '@angular/material/datepicker';
import { PopoverDirective } from 'ngx-bootstrap/popover';

@Component({
    selector: 'app-registru',
    templateUrl: './registru.component.html',
    styleUrls: ['./registru.component.scss'],
})
export class RegistruComponent implements OnInit {
    @ViewChild(AcordAdminDrumComponent) appAcordAdminDrum!: AcordAdminDrumComponent;
    @ViewChild(AutorizatiiConstruireComponent) appAutorizatiiConstruire!: AutorizatiiConstruireComponent;
    @ViewChild(AvizPrincipiuStudiuPubComponent) appAvizPrincipiuStudiuPub!: AvizPrincipiuStudiuPubComponent;
    @ViewChild(AvizPudComponent) appAvizPud!: AvizPudComponent;
    @ViewChild(AvizSupraetajareComponent) appAvizSupraetajare!: AvizSupraetajareComponent;
    @ViewChild(AvizeComponent) appAvize!: AvizeComponent;
    @ViewChild(CertificatUrbanismComponent) appCertificatUrbanism!: CertificatUrbanismComponent;
    @ViewChild(ToateTabelRegistruComponent) appToateTabelRegistru!: ToateTabelRegistruComponent;
    @ViewChild(ConstruireDesfiintareComponent) appConstruireDesfiintare!: ConstruireDesfiintareComponent;
    @ViewChild(ConstruireDesfiintareIngineriestiComponent) appConstruireDesfiintareIngineresti!: ConstruireDesfiintareIngineriestiComponent;
    @ViewChild(OperatiuniNotarialeComponent) appOperatiuniNotariale!: OperatiuniNotarialeComponent;
    @ViewChild(CertificateUrbanismInformareComponent) appCertificateUrbanismInformare!: CertificateUrbanismInformareComponent;
    @ViewChild(AutorizatieConstruireDesfiintareComponent) appAutorizatieConstruireDesfiintare!: AutorizatieConstruireDesfiintareComponent;
    @ViewChild(NotificariComponent) appNotificari!: NotificariComponent;
    @ViewChild(AvizePrimarComponent) appAvizePrimar!: AvizePrimarComponent;

    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    isLoading = false;

    importedDTparams: any;

    defaultParameter: GenericRegistru = {
        id: -1,
        name: 'Toate',
        slug: '-1',
        active: true,
        archived: null,
    };

    isArchived: boolean = false;

    // Info for conditional assign and change status from DT
    registre$!: Observable<GenericRegistru[]>;

    registru_slug: string = '-1';

    // Id-ul registrului selectat (din loadRegistre), trimis ca "type"
    registru_type: number | null = null;

    private registre: GenericRegistru[] = [];

    // List of ids on which we render the Add button
    // allowedRegistruIds = [58, 53, 54, 55, 56, 57, 52];

    allowedRegistreSlugs = [
        // Arhiva
        'acord_administrator_drum', // 58 - dev
        'autorizatii-construire', // 53 - dev
        'avize', // 54 - dev
        'aviz-principiu-studiu-publicitar', // 55 - dev
        'aviz-pud', // 56 - dev
        'aviz-supraetajare', // 57 - dev
        'certificate-urbanism', // 52 - dev

        // Noi
        'autorizatie_construire_desfiintare', // 82
        'certificate_urbanism_informare', // 81
        'construire_desfiintare', // 78
        'construire_desfiintare_ingineresti', // 79
        'notificari', // 83
        'operatiuni_notariale', // 80
        'registru_avize_primar',
    ];

    isEditColumnVisible: boolean = false;

    // Slug-ul '-1' (Toate) sau unul necunoscut afișează tabelul generic
    isToateTabelVisible(): boolean {
        return (
            this.registru_slug === this.defaultParameter.slug ||
            !this.allowedRegistreSlugs.includes(this.registru_slug)
        );
    }

    isAllowedToShowAddDialog(): boolean {
        return (
            this.allowedRegistreSlugs.includes(this.registru_slug) &&
            this.permissionsService.hasPermission(
                'urbanism-module.documents.official-documents.add'
            )
        );
    }

    // Popover dates

    @ViewChild('startCalendar') startCalendar!: MatCalendar<Date>;
    @ViewChild('endCalendar') endCalendar!: MatCalendar<Date>;
    @ViewChild(PopoverDirective) popover!: PopoverDirective;

    today: Date = new Date();
    tomorrow: Date = new Date();
    selectedStartDate: Date = new Date(2025, 0, 1);
    private _selectedEndDate: Date = new Date();
    selectedFilteringButton: string = 'current_year';

    setLastXDays(numberOfDays: number): void {
        const date = new Date();
        date.setDate(this.today.getDate() - numberOfDays);
        this.selectedStartDate = date;
        this.updateCalendarView(this.startCalendar, date);
        this.selectedEndDate = this.today;
        this.updateCalendarView(this.endCalendar, this.today);
        this.rerenderChildDT(this.registru_slug);
        this.selectedFilteringButton = `last_${numberOfDays}_days`;
    }

    setYear(yearsBack: number): void {
        const year = this.today.getFullYear() - yearsBack;
        this.selectedStartDate = new Date(year, 0, 1); // 1 Ianuarie
        this.updateCalendarView(this.startCalendar, this.selectedStartDate);
        this.selectedEndDate = new Date(year, 11, 31);
        this.updateCalendarView(this.endCalendar, this.selectedEndDate);
        this.rerenderChildDT(this.registru_slug);
        this.selectedFilteringButton =
            yearsBack === 0 ? 'current_year' : 'previous_year';
    }

    updateCalendarView(calendar: MatCalendar<Date>, date: Date): void {
        if (calendar) {
            calendar.activeDate = date;
        }
    }

    // Methods used to dinamically select the start date according to the end date

    get selectedEndDate(): Date {
        return this._selectedEndDate;
    }

    set selectedEndDate(date: Date) {
        this._selectedEndDate = date;
        if (this.selectedStartDate > date) {
            this.selectedStartDate = new Date(date);
        }
    }

    closePopover(): void {
        if (this.popover) {
            this.popover.hide();
        }
    }

    formatDate(date: Date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = '0' + month;
        if (day.length < 2) day = '0' + day;

        return [year, month, day].join('-');
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.urbanism.nomenclatoare.registru.listDT;

    constructor(
        private dialog: MatDialog,
        private dialogService: DialogService,
        private registruService: RegistruService,
        private permissionsService: PermissionsService,
        private notificationService: NotificationService,
        private route: ActivatedRoute,
    ) {
        // console.log(
        //     this.permissionsService.hasPermission(
        //         'urbanism-module.documents.official-documents.add'
        //     )
        // );
    }

    ngOnInit(): void {
        this.route.data.subscribe((data) => {
            this.isArchived = data['archived'] === true;
            this.registru_slug = this.defaultParameter.slug;
            this.registru_type = null;
            this.isEditColumnVisible = false;
            this.loadRegistre();
        });
    }

    loadRegistre() {
        this.registre$ = this.registruService.getRegistre().pipe(
            map((results: GenericRegistru[]) =>
                results.filter((registru) =>
                    this.isArchived
                        ? registru.archived === true
                        : registru.archived !== true
                )
            ),
            tap((results) => (this.registre = results)),
            map((results) => [this.defaultParameter, ...results])
        );
    }

    onTableChange(event: MatButtonToggleChange) {
        this.registru_slug = event.value;
        this.registru_type =
            this.registre.find((r) => r.slug === event.value)?.id ?? null;
        this.isEditColumnVisible = false;
    }

    openAddDialog() {
        const dialogRef = this.dialog.open(AddRegistruComponent, {
            ...this.dialogService.getDialogConfig(),
            data: this.registru_slug,
        });
        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                Swal.fire({
                    title: helper.dialogConfig.headers.success,
                    text: 'Registru adăugat cu succes!',
                    icon: 'success',
                    confirmButtonText: helper.dialogConfig.buttonLabels.close,
                    allowOutsideClick: false,
                }).then(() => this.rerenderChildDT(this.registru_slug));
            }
        });
    }

    importDTParams(DTparams: any) {
        if (DTparams) {
            this.importedDTparams = DTparams;
        }
    }

    exportRegister(isCSV: boolean = false) {
        if (this.importedDTparams) {
            this.isLoading = true;

            this.registruService.exportRegistru(this.importedDTparams, isCSV)
                .pipe(finalize(() => (this.isLoading = false)))
                .subscribe({
                    next: (response: any) => {
                        let dataType = response.type;
                        let binaryData = [];
                        binaryData.push(response);
                        let downloadLink = document.createElement('a');
                        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
                        downloadLink.setAttribute('target', '_blank');
                        document.body.appendChild(downloadLink);
                        downloadLink.click();
                        document.body.removeChild(downloadLink);
                    },
                    error: (err) => {
                        let msg;
                        try {
                            // try to catch the message from server
                            msg = err.error.errors.message[0];
                        } catch (error) {
                            // controll output message
                            msg = helper.dialogConfig.generalMessages.error;
                        }
                        this.notificationService.warningSwal(
                            this.errorTitle,
                            msg,
                            this.errorIcon
                        );
                    },
                });
        }
    }

    toggleEditColumn() {
        this.isEditColumnVisible = !this.isEditColumnVisible;
        console.log(this.isEditColumnVisible);
    }

    rerenderChildDT(registruSlug: string) {
        switch (registruSlug) {
            case 'acord_administrator_drum':
                this.appAcordAdminDrum.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAcordAdminDrum.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAcordAdminDrum.rerenderDT();
                break;
            case 'autorizatii-construire':
                this.appAutorizatiiConstruire.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAutorizatiiConstruire.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAutorizatiiConstruire.rerenderDT();
                break;
            case 'avize':
                this.appAvize.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAvize.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAvize.rerenderDT();
                break;
            case 'aviz-principiu-studiu-publicitar':
                this.appAvizPrincipiuStudiuPub.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAvizPrincipiuStudiuPub.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAvizPrincipiuStudiuPub.rerenderDT();
                break;
            case 'aviz-pud':
                this.appAvizPud.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAvizPud.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAvizPud.rerenderDT();
                break;
            case 'aviz-supraetajare':
                this.appAvizSupraetajare.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAvizSupraetajare.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAvizSupraetajare.rerenderDT();
                break;
            case 'certificate-urbanism':
                this.appCertificatUrbanism.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appCertificatUrbanism.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appCertificatUrbanism.rerenderDT();
                break;
            case 'autorizatie_construire_desfiintare':
                this.appAutorizatieConstruireDesfiintare.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAutorizatieConstruireDesfiintare.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAutorizatieConstruireDesfiintare.rerenderDT();
                break;
            case 'certificate_urbanism_informare':
                this.appCertificateUrbanismInformare.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appCertificateUrbanismInformare.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appCertificateUrbanismInformare.rerenderDT();
                break;
            case 'construire_desfiintare':
                this.appConstruireDesfiintare.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appConstruireDesfiintare.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appConstruireDesfiintare.rerenderDT();
                break;
            case 'construire_desfiintare_ingineresti':
                this.appConstruireDesfiintareIngineresti.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appConstruireDesfiintareIngineresti.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appConstruireDesfiintareIngineresti.rerenderDT();
                break;
            case 'notificari':
                this.appNotificari.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appNotificari.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appNotificari.rerenderDT();
                break;
            case 'operatiuni_notariale':
                this.appOperatiuniNotariale.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appOperatiuniNotariale.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appOperatiuniNotariale.rerenderDT();
                break;
            case 'registru_avize_primar':
                this.appAvizePrimar.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appAvizePrimar.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appAvizePrimar.rerenderDT();
                break;
            default:
                this.appToateTabelRegistru.selectedStartDate = this.formatDate(this.selectedStartDate);
                this.appToateTabelRegistru.selectedEndDate = this.formatDate(this.selectedEndDate);
                this.appToateTabelRegistru.rerenderDT();
                break;
        }
    }
}
